import { styled, keyframes } from "@mui/material/styles";

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Loader = styled("div", {
  shouldForwardProp: prop => prop !== "height" && prop !== "width",
})<{ height?: number; width?: number }>(({ theme, width, height }) => ({
  border: "8px solid #f3f3f3",
  borderRadius: "50%",
  borderTop: `8px solid ${theme.palette.institutional.braskemBlue}`,
  width: width || 80,
  height: height || 80,
  animation: `${rotate} 2s linear infinite`,
}));

export default Loader;
